const toTrimmedString = (value) =>
  value === null || typeof value === "undefined" ? "" : String(value).trim();

const PHONE_FORMATTING_PATTERN = /[\s()-]/g;
const CANONICAL_AUSTRALIAN_MOBILE_PATTERN = /^\+614\d{8}$/;
const AUSTRALIAN_MOBILE_WITHOUT_PLUS_PATTERN = /^614\d{8}$/;
const AUSTRALIAN_MOBILE_WITH_TRUNK_ZERO_PATTERN = /^\+6104\d{8}$/;
const LOCAL_AUSTRALIAN_MOBILE_PATTERN = /^04\d{8}$/;
const INTERNATIONAL_E164_PATTERN = /^\+[1-9]\d{6,14}$/;

export const stripTeacherPhoneFormatting = (value) =>
  toTrimmedString(value).replace(PHONE_FORMATTING_PATTERN, "");

export const normalizeTeacherPhoneNumber = (value) => {
  const normalizedValue = stripTeacherPhoneFormatting(value);
  if (!normalizedValue) {
    return "";
  }

  if (CANONICAL_AUSTRALIAN_MOBILE_PATTERN.test(normalizedValue)) {
    return normalizedValue;
  }

  if (AUSTRALIAN_MOBILE_WITHOUT_PLUS_PATTERN.test(normalizedValue)) {
    return `+${normalizedValue}`;
  }

  if (AUSTRALIAN_MOBILE_WITH_TRUNK_ZERO_PATTERN.test(normalizedValue)) {
    return `+614${normalizedValue.slice(5)}`;
  }

  if (LOCAL_AUSTRALIAN_MOBILE_PATTERN.test(normalizedValue)) {
    return `+61${normalizedValue.slice(1)}`;
  }

  if (INTERNATIONAL_E164_PATTERN.test(normalizedValue)) {
    return normalizedValue;
  }

  return "";
};

export const getTeacherPhoneValidationMessage = (
  value,
  {
    required = true,
    requiredMessage = "Phone is required.",
    invalidMessage = "Please enter a valid Australian mobile number.",
  } = {}
) => {
  const normalizedValue = toTrimmedString(value);
  if (!normalizedValue) {
    return required ? requiredMessage : "";
  }

  return normalizeTeacherPhoneNumber(normalizedValue) ? "" : invalidMessage;
};
